export const mockCourses = [
  {
    id: 1,
    title: 'Introduction to Computer Science',
    description: 'Foundational concepts in computer science',
    duration: '12 weeks',
    videos: [
      { id: 1, title: 'Programming Basics', duration: 240, url: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4' },
      { id: 2, title: 'Data Structures', duration: 210, url: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_2mb.mp4' },
      { id: 3, title: 'Algorithms', duration: 225, url: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_3mb.mp4' },
      { id: 4, title: 'Object-Oriented Programming', duration: 200, url: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_4mb.mp4' },
      { id: 5, title: 'Database Fundamentals', duration: 195, url: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_5mb.mp4' }
    ],
    interactiveContent: [
      {
        id: 1,
        videoId: 1,
        type: 'flashcards',
        title: 'Programming Basics Flashcards',
        cards: [
          { front: 'What is a variable?', back: 'A storage location with a name that holds data' },
          { front: 'What is a function?', back: 'A reusable block of code that performs a specific task' },
          { front: 'What is a loop?', back: 'A programming construct that repeats a block of code' }
        ]
      },
      {
        id: 2,
        videoId: 2,
        type: 'scrollable',
        title: 'Data Structures Guide',
        content: 'Complete guide to data structures with examples and explanations...'
      }
    ],
    quizzes: [
      {
        id: 1,
        videoId: 1,
        title: 'Programming Basics Quiz',
        questions: [
          {
            id: 1,
            question: 'What is a variable in programming?',
            options: ['A storage location', 'A function', 'A loop', 'A condition'],
            correct: 0
          },
          {
            id: 2,
            question: 'Which of the following is a programming language?',
            options: ['HTML', 'CSS', 'JavaScript', 'All of the above'],
            correct: 2
          },
          {
            id: 3,
            question: 'What does IDE stand for?',
            options: ['Integrated Development Environment', 'Internet Data Exchange', 'Internal Data Engine', 'Interactive Design Editor'],
            correct: 0
          }
        ]
      },
      {
        id: 2,
        videoId: 2,
        title: 'Data Structures Quiz',
        questions: [
          {
            id: 1,
            question: 'Which data structure follows LIFO principle?',
            options: ['Queue', 'Stack', 'Array', 'Linked List'],
            correct: 1
          },
          {
            id: 2,
            question: 'What is the time complexity of accessing an element in an array?',
            options: ['O(1)', 'O(n)', 'O(log n)', 'O(n²)'],
            correct: 0
          },
          {
            id: 3,
            question: 'Which data structure is best for implementing recursion?',
            options: ['Array', 'Queue', 'Stack', 'Linked List'],
            correct: 2
          }
        ]
      },
      {
        id: 3,
        videoId: 3,
        title: 'Algorithms Quiz',
        questions: [
          {
            id: 1,
            question: 'What is the time complexity of binary search?',
            options: ['O(n)', 'O(log n)', 'O(n²)', 'O(1)'],
            correct: 1
          },
          {
            id: 2,
            question: 'Which sorting algorithm has the best average case time complexity?',
            options: ['Bubble Sort', 'Selection Sort', 'Quick Sort', 'Insertion Sort'],
            correct: 2
          },
          {
            id: 3,
            question: 'What is a greedy algorithm?',
            options: ['Always finds optimal solution', 'Makes locally optimal choices', 'Uses dynamic programming', 'Requires backtracking'],
            correct: 1
          }
        ]
      }
    ]
  },
  {
    id: 2,
    title: 'Advanced Mathematics',
    description: 'Advanced mathematical concepts and applications',
    duration: '10 weeks',
    videos: [
      { id: 6, title: 'Calculus Fundamentals', duration: 235, url: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4' },
      { id: 7, title: 'Linear Algebra', duration: 220, url: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_2mb.mp4' },
      { id: 8, title: 'Statistics', duration: 215, url: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_3mb.mp4' },
      { id: 9, title: 'Probability Theory', duration: 205, url: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_4mb.mp4' }
    ]
  }
];

export const mockStudents = [
  {
    id: 1,
    name: 'Rahul Kumar',
    email: 'rahul@college.edu',
    rollNumber: 'CS001',
    college: 'IIT Delhi',
    enrolledCourse: 1,
    progress: 45,
    status: 'active'
  },
  {
    id: 2,
    name: 'Priya Sharma',
    email: 'priya@college.edu',
    rollNumber: 'CS002',
    college: 'IIT Mumbai',
    enrolledCourse: 1,
    progress: 78,
    status: 'active'
  },
  {
    id: 3,
    name: 'Amit Singh',
    email: 'amit@college.edu',
    rollNumber: 'CS003',
    college: 'IIT Delhi',
    enrolledCourse: 2,
    progress: 23,
    status: 'active'
  }
];

export const mockColleges = [
  {
    id: 1,
    name: 'IIT Delhi',
    email: 'admin@iitd.ac.in',
    phone: '+91-11-2659-1999',
    address: 'Hauz Khas, New Delhi',
    status: 'approved',
    studentsCount: 1250,
    certificatesIssued: 890
  },
  {
    id: 2,
    name: 'IIT Mumbai',
    email: 'admin@iitb.ac.in',
    phone: '+91-22-2572-2545',
    address: 'Powai, Mumbai',
    status: 'approved',
    studentsCount: 1100,
    certificatesIssued: 750
  },
  {
    id: 3,
    name: 'NIT Surathkal',
    email: 'admin@nitk.edu.in',
    phone: '+91-824-247-3000',
    address: 'Surathkal, Karnataka',
    status: 'pending',
    studentsCount: 0,
    certificatesIssued: 0
  }
];

export const mockSMEs = [
  {
    id: 1,
    name: 'Dr. Rajesh Gupta',
    email: 'rajesh@gyansathi.in',
    subject: 'Computer Science',
    experience: '15 years',
    status: 'approved',
    contentUploaded: 45,
    studentsReached: 2500
  },
  {
    id: 2,
    name: 'Prof. Meera Patel',
    email: 'meera@gyansathi.in',
    subject: 'Mathematics',
    experience: '12 years',
    status: 'approved',
    contentUploaded: 38,
    studentsReached: 1800
  }
];

export const mockExamData = {
  id: 1,
  title: 'Computer Science Final Exam',
  duration: 10800, // 3 hours in seconds
  questions: [
    {
      id: 1,
      question: 'What is the time complexity of binary search?',
      options: ['O(n)', 'O(log n)', 'O(n²)', 'O(1)'],
      correct: 1
    },
    {
      id: 2,
      question: 'Which data structure follows LIFO principle?',
      options: ['Queue', 'Stack', 'Array', 'Linked List'],
      correct: 1
    },
    {
      id: 3,
      question: 'What does SQL stand for?',
      options: ['Structured Query Language', 'Simple Query Language', 'Standard Query Language', 'Sequential Query Language'],
      correct: 0
    }
  ]
};